
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import GoAroundApi from "../../API/goAroundApi";
import HouseSelection from "../HouseSelection";
import useStore from "../../Store";
import FloorSelection from "../floorSelection";
import StatisticApi from "../../API/StatisticApi";
import DataSelection from "./dataSelection";

const IMAGE_BASE_URL = "http://85.215.217.91:999/GoAround/Images/";

// ===== Styled Components =====

const Container = styled.div`
    padding: 20px;
    width: 100%;
    box-sizing: border-box;
`;

const Title = styled.h2`
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
`;

const Message = styled.p`
    text-align: center;
    color: #777;
    font-size: 16px;
`;

const Gallery = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 15px;

    @media (max-width: 600px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 10px;
    }
`;

const PhotoCard = styled.button`
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    aspect-ratio: 1 / 1;

    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: scale(1.03);
        box-shadow: 0 5px 18px rgba(0, 0, 0, 0.25);
    }

    &:focus-visible {
        outline: 3px solid #3b82f6;
        outline-offset: 3px;
    }
`;

const Photo = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const Lightbox = styled.div`
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.92);

    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 9999;
`;

const LargePhoto = styled.img`
    max-width: ${({ $rotated }) => $rotated ? "75vh" : "85vw"};
    max-height: ${({ $rotated }) => $rotated ? "75vw" : "80vh"};

    width: auto;
    height: auto;
    object-fit: contain;

    transform: rotate(${({ $rotation }) => $rotation}deg);
    transition: transform 0.3s ease;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 20px;
    right: 25px;
    z-index: 2;

    background: none;
    border: none;
    color: white;
    font-size: 36px;
    line-height: 1;
    cursor: pointer;

    &:hover {
        color: #bbb;
    }
`;

const ArrowButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${({ $direction }) => $direction}: 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 48px;
    height: 48px;
    border: none;
    border-radius: 50%;

    background: rgba(255, 255, 255, 0.15);
    color: white;
    font-size: 26px;
    cursor: pointer;
    z-index: 2;

    transition: background 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
    }

    @media (max-width: 600px) {
        width: 38px;
        height: 38px;
        font-size: 20px;

        ${({ $direction }) => $direction}: 8px;
    }
`;

const PhotoCounter = styled.div`
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);

    color: white;
    font-size: 16px;
    background: rgba(0, 0, 0, 0.4);
    padding: 6px 16px;
    border-radius: 20px;
`;

const RotateControls = styled.div`
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);

    display: flex;
    gap: 15px;
    z-index: 3;
`;

const RotateButton = styled.button`
    width: 48px;
    height: 48px;

    display: flex;
    justify-content: center;
    align-items: center;

    border: none;
    border-radius: 50%;

    background: rgba(255, 255, 255, 0.2);
    color: white;
    font-size: 25px;

    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.4);
    }
`;

const StatisticPhoto = () => {
    const [date, setDate] = useState();
    const [dates, setDates] = useState([]);
    const houses=useStore((state)=>state.Houses.Location1);
    const floors=useStore((state)=>state.Floors);
    const [selectedHouse, setSelectedHouse] = useState(null);
    const [selectedFloor, setSelectedFloor] = useState(null);
    const [photosData, setPhotosData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [rotation, setRotation] = useState(0);

    useEffect(() => {
        let active = true;

        date&&GoAroundApi.getImages(date)
            .then((res) => {
                if (active) {
                    setPhotosData(res.data ?? res);
                }
            })
            .catch((err) => {
                if (active) {
                    console.error("Fehler beim Laden:", err);
                    setError("Bilder konnten nicht geladen werden.");
                }
            })
            .finally(() => {
                if (active) {
                    setLoading(false);
                }
            });

        return () => {
            active = false;
        };
    }, [date]);

    const photos = (photosData?.Images ?? []).filter(
        (photo) =>         photo.house_name === selectedHouse &&
            photo.floor === selectedFloor
    );

    const getImageUrl = (photo) =>
        IMAGE_BASE_URL + encodeURIComponent(photo.image_file_name);

    const closePhoto = () => {
        setRotation(0);
        setSelectedIndex(null);
    };

    const nextPhoto = () => {
        setRotation(0);
        setSelectedIndex((prev) =>
            prev === null ? null : (prev + 1) % photos.length
        );
    };

    const previousPhoto = () => {
        setRotation(0);
        setSelectedIndex((prev) =>
            prev === null
                ? null
                : (prev - 1 + photos.length) % photos.length
        );
    };
    const rotateRight = () => {
        setRotation(prev => prev + 90);
    };

    const rotateLeft = () => {
        setRotation(prev => prev - 90);
    };
    useEffect(() => {
        if (selectedIndex === null || photos.length === 0) return;

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                closePhoto();
            }

            if (event.key === "ArrowRight") {
                nextPhoto();
            }

            if (event.key === "ArrowLeft") {
                previousPhoto();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [selectedIndex, photos.length]);

    useEffect(() => {
        if (selectedIndex === null) return;

        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, [selectedIndex]);

    useEffect(() => {
        setSelectedIndex(null);

    }, [selectedHouse,selectedFloor]);
    useEffect(()=>{
        StatisticApi.getImagesDates().then((res)=>{
            let temp=[]
            res.Dates.map((date)=>{
                temp.push(date.date)
            })
            setDates(temp)
        })
    },[])
    useEffect(()=>{

    },[selectedHouse,selectedFloor])
    console.log(photosData)
    return (
        <>
            <HouseSelection
                houses={houses}
                selectedHouse={selectedHouse}
                setSelectedHouse={setSelectedHouse}
            />
            <FloorSelection
                Floors={floors}
                selectedHouse={selectedHouse}
                selectedFloor={selectedFloor}
                setSelectedFloor={setSelectedFloor}
            />
            <DataSelection
                dates={dates}
                selectedDate={date}
                setSelectedDate={setDate}
            />
        <Container>
            <Title>Fotogalerie – {date}</Title>

            {/*{loading && <Message>Bilder werden geladen...</Message>}*/}

            {/*{error && <Message>{error}</Message>}*/}

            {!loading && !error && photos.length === 0 && (
                <Message>Keine Bilder vorhanden.</Message>
            )}

            <Gallery>
                {photos.map((photo, index) => (
                    <PhotoCard
                        key={photo.id ?? photo.image_file_name ?? index}
                        type="button"
                        onClick={() => setSelectedIndex(index)}
                        aria-label={`Foto ${index + 1} öffnen`}
                    >
                        <Photo
                            src={getImageUrl(photo)}
                            alt={`Foto ${index + 1}`}
                            loading="lazy"
                        />
                    </PhotoCard>
                ))}
            </Gallery>

            {selectedIndex !== null && photos[selectedIndex] && (
                <Lightbox
                    role="dialog"
                    aria-modal="true"
                    aria-label="Fotoansicht"
                    onClick={closePhoto}
                >
                    <CloseButton
                        type="button"
                        aria-label="Schließen"
                        onClick={closePhoto}
                    >
                        ×
                    </CloseButton>

                    {photos.length > 1 && (
                        <ArrowButton
                            type="button"
                            $direction="left"
                            aria-label="Vorheriges Foto"
                            onClick={(event) => {
                                event.stopPropagation();
                                previousPhoto();
                            }}
                        >
                            ❮
                        </ArrowButton>
                    )}

                    <LargePhoto
                        src={getImageUrl(photos[selectedIndex])}
                        alt={`Foto ${selectedIndex + 1}`}
                        $rotation={rotation}
                        $rotated={Math.abs(rotation % 180) === 90}
                        onClick={(event) => event.stopPropagation()}
                    />
                    <RotateControls>
                        <RotateButton
                            type="button"
                            title="Nach links drehen"
                            onClick={(event) => {
                                event.stopPropagation();
                                rotateLeft();
                            }}
                        >
                            ↶
                        </RotateButton>

                        <RotateButton
                            type="button"
                            title="Nach rechts drehen"
                            onClick={(event) => {
                                event.stopPropagation();
                                rotateRight();
                            }}
                        >
                            ↷
                        </RotateButton>
                    </RotateControls>
                    {photos.length > 1 && (
                        <ArrowButton
                            type="button"
                            $direction="right"
                            aria-label="Nächstes Foto"
                            onClick={(event) => {
                                event.stopPropagation();
                                nextPhoto();
                            }}
                        >
                            ❯
                        </ArrowButton>
                    )}

                    <PhotoCounter>
                        {selectedIndex + 1} / {photos.length}
                    </PhotoCounter>
                </Lightbox>
            )}
        </Container>
        </>
    );
};

export default StatisticPhoto;
